import { useEffect } from 'react';
import styles from './CourseDetail.module.css';

/**
 * Hook to handle hash-based highlighting on page load and hash changes
 * Adds the CSS module 'highlighted' class for ~800ms when navigating via hash
 * 
 * @param {Array} sections - Array of section IDs
 */
export const useHashHighlight = (sections = []) => {
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1); // Remove #
      if (hash && sections.includes(hash)) {
        const element = document.getElementById(hash);
        if (element) {
          element.classList.add(styles.highlighted);
          setTimeout(() => {
            element.classList.remove(styles.highlighted);
          }, 800);
        }
      }
    };

    // Check on mount
    if (window.location.hash) {
      handleHashChange();
    }

    // Listen for hash changes
    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [sections]);
};

export default useHashHighlight;

